export default __webpack_public_path__ + "static/media/135.b3e5ccf5.png";